import React from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface MessageCardProps {
  title: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
}

// Shared Patient Portal message card (empty and waiting states).
const MessageCard = ({ title, children, icon }: MessageCardProps) => (
  <Paper sx={{ p: 3 }}>
    <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="flex-start">
      {icon && (
        <Avatar sx={{ bgcolor: "primary.light", color: "primary.main" }}>{icon}</Avatar>
      )}
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          {title}
        </Typography>
        {children}
      </Box>
    </Stack>
  </Paper>
);

export default MessageCard;
